import ProfilePageBody from "../components/profilepage/ProfilePageBody";

const ProfilePage = () => {
    return(
        //<AddCard />
        <ProfilePageBody />
    );
}

export default ProfilePage;